<template>
    <div v-show="showLegend">
        <div class="map_legend" v-show="selectedTopMenu === 'Safety'">
            <ul class="leg_tit">
                <li class="tit tit01 on">재난안전</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="safety">
                            <li><i><img src="@/assets/images/marker/marker_safety_0.png" alt=""></i> 재난</li>
                            <li><i><img src="@/assets/images/marker/marker_safety_1.png" alt=""></i> 화재</li>
                            <li><i><img src="@/assets/images/marker/marker_safety_2.png" alt=""></i> 구조</li>
                            <li><i><img src="@/assets/images/marker/marker_safety_3.png" alt=""></i> 구급</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Accident'">
            <ul class="leg_tit">
                <li class="tit tit01 on">도로교통</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="safety">
                            <li><i><img src="@/assets/images/marker/marker_accident_1.png" alt=""></i> 사고</li>
                            <li><i><img src="@/assets/images/marker/marker_accident_2.png" alt=""></i> 공사</li>
                            <li><i><img src="@/assets/images/marker/marker_accident_3.png" alt=""></i> 행사</li>
                            <li><i><img src="@/assets/images/marker/marker_accident_5.png" alt=""></i> 통제</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Accident' && showTrafficLayer">
            <ul class="leg_tit">
                <li class="tit tit01 on">교통상황</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="traffic01">
                            <li><span class="st01">원활</span></li>
                            <li><span class="st02">서행</span></li>
                            <li><span class="st03">지체</span></li>
                            <li><span class="st04">정체</span></li>
                            <li><span class="st05">정보없음</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Air' && selectedSubMenu === 'pm10'">
            <ul class="leg_tit">
                <li class="tit tit01 on">미세먼지</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="air">
                            <li><span class="st01">좋음</span></li>
                            <li><span class="st02">보통</span></li>
                            <li><span class="st03">나쁨</span></li>
                            <li><span class="st04">매우나쁨</span></li>
                            <li><span class="st05">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Air' && selectedSubMenu === 'pm25'">
            <ul class="leg_tit">
                <li class="tit tit01 on">초미세먼지</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="air">
                            <li><span class="st01">좋음</span></li>
                            <li><span class="st02">보통</span></li>
                            <li><span class="st03">나쁨</span></li>
                            <li><span class="st04">매우나쁨</span></li>
                            <li><span class="st05">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Air' && selectedSubMenu === 'no2'">
            <ul class="leg_tit">
                <li class="tit tit01 on">이산화질소</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="air">
                            <li><span class="st01">좋음</span></li>
                            <li><span class="st02">보통</span></li>
                            <li><span class="st03">나쁨</span></li>
                            <li><span class="st04">매우나쁨</span></li>
                            <li><span class="st05">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Air' && selectedSubMenu === 'o3'">
            <ul class="leg_tit">
                <li class="tit tit01 on">오존</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="air">
                            <li><span class="st01">좋음</span></li>
                            <li><span class="st02">보통</span></li>
                            <li><span class="st03">나쁨</span></li>
                            <li><span class="st04">매우나쁨</span></li>
                            <li><span class="st05">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Air' && selectedSubMenu === 'decibel'">
            <ul class="leg_tit">
                <li class="tit tit01 on">소음</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="air">
                            <li><span class="st01">정상</span></li>
                            <li><span class="st02">보통</span></li>
                            <li><span class="st03">나쁨</span></li>
                            <li><span class="st04">매우나쁨</span></li>
                            <li><span class="st05">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Air' && selectedSubMenu === 'rain'" style="height: 120px;">
            <ul class="leg_tit">
                <li class="tit tit01 on">하천수위</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="rain">
                            <li><span class="st01">보통</span></li>
                            <li><span class="st02">경보</span></li>
                            <li><span class="st03">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <ul class="leg_tit">
                <li class="tit tit01 on">강우량</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="rainfall">
                            <li><span class="st01">보통</span>0~60</li>
                            <li><span class="st02">주의</span>60~90</li>
                            <li><span class="st03">경보</span>90~</li>
                            <li><span class="st04">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Air' && selectedSubMenu === 'mosquito'">
            <ul class="leg_tit">
                <li class="tit tit01 on">모기방역건수</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="mosquito">
                            <li><span class="st04">상위25%이상</span></li>
                            <li><span class="st03">26%~50%</span></li>
                            <li><span class="st02">51%~75%</span></li>
                            <li><span class="st01">하위76%이하</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Air' && selectedSubMenu === 'mediumMosq'">
            <ul class="leg_tit">
                <li class="tit tit01 on">일 평균 모기 개체수</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="mediumMosq">
                            <li><span class="st01">0~25 미만</span></li>
                            <li><span class="st02">25~50 미만</span></li>
                            <li><span class="st03">50~75 미만</span></li>
                            <li><span class="st04">75~100 미만</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Water' && selectedSubMenu === 'val7'">
            <ul class="leg_tit">
                <li class="tit tit01 on">pH</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="water">
                            <li><span class="st01">정상</span></li>
                            <li><span class="st02">수질이상</span></li>
                            <li><span class="st03">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Water' && selectedSubMenu === 'val8'">
            <ul class="leg_tit">
                <li class="tit tit01 on">잔류염소</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="water">
                            <li><span class="st01">정상</span></li>
                            <li><span class="st02">수질이상</span></li>
                            <li><span class="st03">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

        <div class="map_legend" v-show="selectedTopMenu === 'Water' && selectedSubMenu === 'val9'">
            <ul class="leg_tit">
                <li class="tit tit01 on">탁도</li>
            </ul>
            <div class="leg_conts">
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="water">
                            <li><span class="st01">정상</span></li>
                            <li><span class="st02">수질이상</span></li>
                            <li><span class="st03">점검중</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeLegend()">닫기</a></div>
        </div>

    </div>
</template>

<script>
import { $_WC } from '@/confs/common.const';
import gripUtil from "@/libs/grip.util";
import {mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters({
            showLegend: 'getShowLegend',
            selectedTopMenu: 'getSelectedTopMenu',
            selectedSubMenus: 'getSelectedSubMenus',
            facilitiesMenu: 'getFacilitiesMenu',
        }),
        selectedSubMenu(){
            return this.selectedSubMenus[0];
        },
        showTrafficLayer(){
            let map = gripUtil.toDict(this.facilitiesMenu['Accident'], 'id');
            return map['trafficState'].isChecked;
        },
        is4K() {
            return $_WC.is4K;
        },
    },
    methods: {
        closeLegend(){
            this.$store.dispatch('SET_SHOW_LEGEND', false);
        },
    },
};
</script>
<style>
    @media (min-width: 2737px) and (max-width: 7680px){
        .map_legend .leg_list .mediumMosq>li {
            font-size: 17px;
        }
    }
</style>